














































import Vue from 'vue'
import Lottie from 'vue-lottie'
import {Component, Prop, Watch} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import {sleep} from '@/utils/async'

@Component<ScorecardSubpage>({
    components: {Lottie}
})
export default class ScorecardSubpage extends Vue {
    public animationData ?: any = null

    @Prop({type: String, default: ''}) public badgeId !: string
    @Prop({type: Boolean, default: false}) public sticky !: string
    @Prop({type: Boolean, default: true}) public showHeader !: boolean
    @Prop({type: Boolean, default: true}) public showBack !: boolean
    @Prop({type: String, default: ''}) public buttonRight !: string
    @Prop({type: String, default: ''}) public title !: string
    @Prop({type: String, default: '#F4F6FC'}) public bgColor !: string
    @Prop({type: String, default: 'left'}) public slide!: string

    @Action public setSlide

    public slideName = `slide-${this.slide}`

    public async mounted() {
        this.animationData = (await import(`@/assets/img/scorecard/animated/${this.badgeId}.json`)).default
    }

    @Watch('slide')
    public updateSlide() {
        this.slideName = `slide-${this.slide}`
    }

    public async goBack() {
        // set back page slide right in
        this.setSlide('right') // new page slide right in
        await sleep(10)
        this.slideName = 'slide-left' // we slide left out
        this.$router.back()
    }

    public get isBlackArrow() {
        if (this.badgeId === 'unknown-badge') {
            return true
        }
        return !this.animationData
    }
}
